/** @jsx jsx */
import { jsx } from "theme-ui"
import { Link, StaticQuery, graphql } from "gatsby"
import { RiArrowDownLine, RiArrowRightSLine } from "react-icons/ri"
import { Divider } from "theme-ui"

import PostCard from "./post-card"

const PostMaker = ({ data }) => (
  <section className="home-posts">
    <Divider />
    <h2 className="title">Recent Work</h2>
    <p className="subtitle">Explore Case Studies</p>
    <div className="grids col-1 sm-2 lg-2">{data}</div>
    <Link
      className="button"
      to="/recent-works"
      sx={{
        variant: "links.button",
      }}
    >
      See more works
      <span class="icon -right">
        <RiArrowRightSLine />
      </span>
    </Link>
  </section>
)

export default function RecentWorkHome() {
  return (
    <StaticQuery
      query={graphql`
        query {
          allMarkdownRemark(
            sort: { order: DESC, fields: [frontmatter___date] }
            filter: { frontmatter: { template: { eq: "recent-work" } } }
            limit: 6
          ) {
            edges {
              node {
                id
                excerpt(pruneLength: 250)
                frontmatter {
                  date(formatString: "MMMM DD, YYYY")
                  slug
                  title
                  synopsis
                  featuredImage {
                    childImageSharp {
                      fluid(maxWidth: 540, maxHeight: 360, quality: 80) {
                        ...GatsbyImageSharpFluid
                        ...GatsbyImageSharpFluidLimitPresentationSize
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        const posts = data.allMarkdownRemark.edges
          .filter(edge => !!edge.node.frontmatter.date)
          .map(edge => <PostCard key={edge.node.id} data={edge.node} />)
        return <PostMaker data={posts} />
      }}
    />
  )
}
